export const styledUl = {
    listStyleType: 'none',
    paddingLeft: 0,
}

export const styledLi = {display: 'flex'}

export const styledButton = {
    '&:hover': {backgroundColor: '$cannedMessageBackgroundHover'},
    'background': 'transparent',
    'border': 0,
    'display': 'flex',
    'flexDirection': 'column',
    'flexGrow': 1,
    'padding': '0.4rem',
    'textAlign': 'left',
}

export const styledKeyword = {color: '$cannedMessageKeywordText'}

export const styledMessage = {
    color: '$cannedMessageText',
    whiteSpace: 'pre-line',
}
